import { SalesMetroAdapters } from '../adapters';
import { SalesMetrosApi } from '../clients';

/**
 * The one metro that owns `zip`, or `null` when nobody does.
 *
 * At most one row can come back — zip is the primary key of the table the
 * handler resolves it through — and an unowned zip is a 200 with empty `items`,
 * not an error.
 *
 * @param {string} zip - Exactly five digits; anything else is a 422.
 * @returns {Promise<import('../types/SalesMetro').ISalesMetro | null>}
 */
export const findSalesMetroByZip = async (zip) => {
  const response = await SalesMetrosApi.getSalesMetros({ zip, page: 1 });
  const [model] = response?.items ?? [];

  return model?.id ? SalesMetroAdapters.toSalesMetro(model) : null;
};
